<template>
  <div class="manage-alerts-component screen">
    <ModalHeader
      v-if="$isMobile"
      :config="{
        type: 'back',
        screenName: 'alerts',
        screenType: 'drawer',
        hasVehiclePicker: true,
        title: 'Manage alerts',
        subTitle: '',
      }"
      @close="beforeClose()"
    />
    <div class="header-band" v-else>
      <button class="back-button" @click="goBack()">
        <img src="@/assets/images/backArrow.svg" alt="back" />
        Back
      </button>
      <div class="divider"></div>
      <div class="vehicle-picker-container">
        <VehiclePickerMenu />
      </div>
      <div class="divider divider-wide"></div>
      <div class="heading">Manage Alerts</div>
      <CloseButton variant="light" inline @click="beforeClose()" />
    </div>
    <div class="top">
      <div class="heading" v-if="$isMobile">Manage alerts</div>
      <div class="button">
        <button class="btn btn-outline" :disabled="processing" @click="showModal('new-alert-entry')">
          <span v-show="!processing" v-if="$isMobile">New alert</span>
          <span v-show="!processing" v-else>Create new alert</span>
          <Spinner v-show="processing" />
        </button>
      </div>
    </div>
    <Alert />
    <div class="panel">
      <PanelSpinner v-if="loading" />
      <SmoothReflow>
        <div class="item container" v-for="(item, i) in alerts" :key="item.Id">
          <div class="row align-items-center text-center text-md-left">
            <div class="col-md-5 mb-2 mb-md-0">
              <div class="d-flex align-items-center justify-content-center justify-content-md-start">
                <img :src="getAlertIconURL(item.EditorMetadata)" class="alert-icon" width="34" height="34" alt />
                <span class="alert-name">{{ item.Name }}</span>
              </div>
            </div>
            <div class="col-md-4 mb-3 mb-md-0 alert-type">{{ item.EditorMetadata }}</div>
            <div class="col-md-3 mb-2 mb-md-0 d-flex justify-content-center align-items-center" style="gap: 26px;">
              <Spinner v-if="processing && toggledAlertId === item.Id" />
              <div class="custom-control custom-switch" v-else>
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'alertActive' + i"
                  v-model="item.Active"
                  :disabled="processing"
                  @click="toggleActive(item)"
                />
                <label class="custom-control-label" :for="'alertActive' + i" />
              </div>
              <img src="~@/assets/images/edit.svg" class="button" width="25" height="25" alt @click="edit(item)" />
              <svg xmlns="http://www.w3.org/2000/svg" width="13.836" height="13.837" viewBox="0 0 13.836 13.837" class="delete-icon button" fill="currentColor" @click="deleteAlert(item.Id)">
                <g id="Group_4063" data-name="Group 4063" transform="translate(13.086 0.75) rotate(90)">
                  <path id="Path_8639" data-name="Path 8639" d="M-5614.277,57.633a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061l12.337-12.336a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061l-12.337,12.336A.748.748,0,0,1-5614.277,57.633Z" transform="translate(5614.277 -44.547)" fill="#140047"/>
                  <path id="Path_8640" data-name="Path 8640" d="M-5601.94,57.633a.748.748,0,0,1-.53-.22l-12.337-12.336a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0l12.337,12.336a.75.75,0,0,1,0,1.061A.748.748,0,0,1-5601.94,57.633Z" transform="translate(5614.277 -44.547)" fill="#140047"/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </SmoothReflow>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.manage-alerts-component {
  .header-band {
    display: flex;
    align-items: center;
    background-color: $brand-color-1;
    padding: 12px 30px;
    margin: -20px -30px 25px -30px;
    color: #fff;
    position: relative;
    font-size: 19px;
    font-weight: 300;

    .back-button {
      display: flex;
      align-items: center;
      background: none;
      color: #fff;
      padding: 0;
      border: none;
      font-size: 1.1875rem;
      font-weight: 300;

      img {
        margin-right: 8px;
      }

      &:focus {
        outline: none;
      }
    }

    .divider {
      width: 1px;
      height: 20px;
      background-color: #fff;
      margin: 0 15px;

      &.divider-wide {
        margin: 0 25px 0 15px;
      }
    }

    .vehicle-picker-container {
      padding: 0;

      /deep/ .menu__link {
        font-size: 1.1875rem;
        font-weight: 300;
      }
    }

    .heading {
      font-size: 1.1875rem;
      font-weight: 600;
      color: #fff;
    }
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    .heading {
      font-weight: 600;
      font-size: 1.1875rem;
    }

    .button {
      margin-left: auto;

      button {
        min-width: 92px;
        height: 32px;
        font-size: 14px;
        font-weight: 600;
      }
    }
  }

  .panel {
    background: $brand-color-4;
    padding: 20px;

    .item {
      background: #fff;
      padding-top: 10px;
      padding-bottom: 10px;
      min-height: 64px;
      margin-bottom: 15px;
      box-shadow: $drop-shadow-light;

      &:last-of-type {
        margin-bottom: 0;
      }

      .row {
        position: relative;
        min-height: 44px;
      }

      .row > [class*="col-md"] {
        position: static;

        &:after {
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          height: 40px;
          border-right: 1px solid $brand-color-3;
        }

        &:nth-child(1):after {
          left: calc(41.666667% - 1px);
        }

        &:nth-child(2):after {
          left: calc(75% - 1px);
        }

        &:last-child:after {
          display: none;
        }
      }

      .alert {
        &-icon {
          margin-right: 15px;
        }

        &-name {
          position: relative;
          padding-left: 15px;

          &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            height: 40px;
            transform: translateY(-50%);
            border-left: 1px solid $brand-color-3;
          }
        }
      }

      @media (max-width: 767px) {
        .row > [class*="col-md"]:after {
          display: none;
        }

        .row > .col-md-3 {
          gap: 40px !important;
        }

        .alert-icon {
          margin-right: 15px !important;
        }

        .alert-name {
          padding-left: 10px !important;

          &:before {
            left: -5px;
            height: 30px;
            border-left: 1px solid #d50000;
          }
        }
      }

      .alert-type {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 15px;
      }

      .custom-switch {
        margin-right: -10px;
      }

      .delete-icon {
        vertical-align: middle;
      }

      .button {
        vertical-align: middle;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import { alertService, assetService, modalService } from "@/services";
import CloseButton from "@/components/CloseButton";
import VehiclePickerMenu from "@/components/screens/VehiclePickerMenu";
import ModalHeader from "@/components/screens/ModalHeader";

export default {
  name: "Alerts",
  components: {
    CloseButton,
    VehiclePickerMenu,
    ModalHeader,
  },
  data() {
    return {
      loading: true,
      processing: false,
      toggledAlertId: null,
      alerts: [],
    };
  },
  computed: {
    ...mapGetters("asset", ["getActiveSafeAndSoundVehicleId"]),
    activeAssetId() {
      return this.getActiveSafeAndSoundVehicleId();
    },
  },
  created() {
    const vehicleId = this.getActiveSafeAndSoundVehicleId();
    const startTime = Date.now();
    assetService
      .getVehicleAlerts(vehicleId)
      .then((data) => {
        const timeElapsed = Date.now() - startTime;
        setTimeout(
          () => {
            this.alerts = data;
            this.loading = false;
          },
          timeElapsed < 500 ? 500 - timeElapsed : 0
        );
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  methods: {
    beforeClose() {
      this.$emit("close");
    },
    goBack() {
      if (this.$isMobile) {
        this.$emit("close");
      } else {
        modalService.showLeftDrawer(this, "alerts");
      }
    },
    showModal(screenName, parameters = {}) {
      modalService.showModal(this, screenName, parameters);
    },
    getAlertIconURL(category) {
      let url = "";
      switch (category) {
        case "Acceleration":
          url = require("@/assets/images/trips/harsh-acceleration.svg");
          break;
        case "Braking":
          url = require("@/assets/images/trips/harsh-braking.svg");
          break;
        case "Cornering":
          url = require("@/assets/images/trips/harsh-cornering.svg");
          break;
        case "Geo-Fencing":
          url = require("@/assets/images/trips/geo-zone.svg");
          break;
        case "Impacts":
          url = require("@/assets/images/trips/impacts.svg");
          break;
        case "Lane-Change":
          url = require("@/assets/images/trips/lane-changing.svg");
          break;
        case "Speeding":
          url = require("@/assets/images/trips/over-speeding.svg");
          break;
        case "Time Rule":
          url = require("@/assets/images/trips/time-rule.svg");
          break;
      }
      return url;
    },
    edit(alert) {
      this.showModal("new-alert", {
        alert: alert,
      });
    },
    deleteAlert(alertId) {
      modalService.showDeleteDialog("Are you sure you want to delete this alert?", () => {
        this.processing = true;
        assetService
          .deleteVehicleAlert(alertId)
          .then((result) => {
            this.processing = false;
            if (result) {
              this.alerts = this.alerts.filter((item) => item.Id !== alertId);
            } else {
              alertService.showErrorAlert();
            }
          })
          .catch((error) => {
            this.processing = false;
            alertService.showErrorAlert();
          });
      });
    },
    toggleActive(alert) {
      this.processing = true;
      this.toggledAlertId = alert.Id;
      const alertCopy = JSON.parse(JSON.stringify(alert));
      alertCopy.Active = !alertCopy.Active;

      assetService
        .updateVehicleAlert(alertCopy)
        .then((result) => {
          this.processing = false;
          if (result) {
            alert.Active = !alert.Active;
          } else {
            alertService.showErrorAlert();
          }
          this.toggledAlertId = null;
        })
        .catch((error) => {
          this.processing = false;
          this.toggledAlertId = null;
          alertService.showErrorAlert();
        });
    },
  },
  watch: {
    activeAssetId() {
      this.processing = true;
      const vehicleId = this.getActiveSafeAndSoundVehicleId();
      assetService
        .getVehicleAlerts(vehicleId)
        .then((data) => {
          this.alerts = data;
          this.processing = false;
        })
        .catch((error) => {
          this.processing = false;
        });
    },
  },
};
</script>